import { Col, Input, Row } from 'reactstrap';
import { useTranslation } from 'react-i18next';

interface TableHeaderProps {
  rowsPerPage: number;
  rowsOptions: number[];
  onChange: (value: number) => void;
  button?: any;
}

const TableHeader = (props: TableHeaderProps) => {
  const { t } = useTranslation();

  return (
    <div className="table invoice-list-table-header w-100 ">
      <Row>
        <Col xl="6" className="d-flex align-items-center p-0">
          <div className="d-flex align-items-center w-100">
            <label htmlFor="rows-per-page">{t('SHOW')}</label>
            <Input
              className="mx-50"
              type="select"
              id="rows-per-page"
              value={props.rowsPerPage}
              onChange={(e) => props.onChange(+e.target.value)}
              style={{ width: '5rem' }}
            >
              {props.rowsOptions.length ? (
                props.rowsOptions.map((option) => (
                  <option value={option} key={option}>
                    {option}
                  </option>
                ))
              ) : (
                <option value="10">10</option>
              )}
            </Input>
          </div>
        </Col>
        {props.button && (
          <Col
            xl="6"
            className="d-flex align-items-sm-center justify-content-xl-end justify-content-start flex-xl-nowrap flex-wrap flex-sm-row flex-column pe-xl-1 p-0 mt-xl-0 mt-1"
          >
            {props.button}
          </Col>
        )}
      </Row>
    </div>
  );
};

export default TableHeader;
